import { render } from "./EventsView.vue?vue&type=template&id=fb039a0e&scoped=true&ts=true"
import script from "./EventsView.vue?vue&type=script&lang=ts"
export * from "./EventsView.vue?vue&type=script&lang=ts"

import "./EventsView.vue?vue&type=style&index=0&id=fb039a0e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb039a0e"]])

export default __exports__